import { saveVoucherInfo } from '@shared/redux/actions';
import { getHotelSales } from '@shared/services/services';
import { HOTEL_VOUCHER } from '@shared/helpers/routes';
import { validateCardInfo } from './helpers';
import { buildTrackingData, trackEvent } from '../helpers/bookingFlow';
import {
  BOOKING_ERROR_TYPES,
  ERROR_COPY,
} from '@shared/constants/bookingErrors';

const getBookingErrorInfo = ({ error, paymentResult }) => {
  const message = error?.response?.data?.message || '';

  if (message.startsWith('No se encuentra tarifa con id transaction')) {
    return {
      errorType: BOOKING_ERROR_TYPES.TIME_EXPIRED,
      errorMessage: ERROR_COPY[BOOKING_ERROR_TYPES.TIME_EXPIRED].message,
    };
  }

  if (paymentResult?.status === 'failed') {
    return {
      errorType: BOOKING_ERROR_TYPES.PAYMENT_ERROR,
      errorMessage: ERROR_COPY[BOOKING_ERROR_TYPES.PAYMENT_ERROR].message({
        isSucursal: false,
      }),
    };
  }

  return {
    errorType: BOOKING_ERROR_TYPES.GENERIC,
    errorMessage:
      'Ocurrió un inconveniente con tu reserva. Por favor, intentá nuevamente.',
  };
};

const buildPaymentObject = (infoCard, baseBookingBody, subsidiary) => ({
  card_number: infoCard.cardInfo.number,
  card_exp_month: infoCard.cardInfo.card_exp_month,
  card_exp_year: infoCard.cardInfo.card_exp_year,
  card_code_value: infoCard.cardInfo.cvc,
  currency: 'ARS',
  card_holder_name: infoCard.cardInfo.name,
  card_holder_identification_type: 'dni',
  card_holder_identification_number: infoCard.cardInfo.dni,
  payment_plan_id: infoCard.idPlan,
  client_email: baseBookingBody.passenger_email,
  agency_email: subsidiary?.email,
  agency_name: subsidiary?.name,
  agency_business_name: subsidiary?.business_name,
  ref_passenger: '-',
  file_number: '-',
});

const buildHotelPayment = values => ({
  billing: {
    ownerCardName: values.ownerCardName,
    ownerDocument: values.ownerDocument,
    afip: values.afip,
    street: values.street,
    streetNumber: values.streetNumber,
    floor: values.floor,
    department: values.department,
    city: values.city,
    postalCode: values.postalCode,
    province: values.province,
  },
});

export const sendBuyForm = async ({
  infoCard,
  showBillingError,
  baseBookingBody,
  subsidiary,
  search,
  pricesDetail,
  hotelDetails,
  user,
  values,
  id_integration,
  detailTransaction,
  passengerDetails,
  history,
  dispatch,
  seller,
  room,
  total,
  price,
  cardData,
  cancelationFee,
  hotelsValidateResult,
}) => {
  if (!infoCard || validateCardInfo(infoCard)) {
    showBillingError({
      title: 'Hubo un error en la carga de datos de la tarjeta.',
      message:
        'Por favor, verifique la información ingresada e intente nuevamente.',
      subText: '',
    });
    return;
  }

  if (room.board?.code) {
    room.rooms.board_code = room.board.code;
  }

  const paymentObject = buildPaymentObject(
    infoCard,
    baseBookingBody,
    subsidiary
  );
  const hotelPayment = buildHotelPayment(values);

  const bookingBody = {
    id_transaction: room.id_transaction,
    payment_object: paymentObject,
    booking_object: {
      ...baseBookingBody,
      hotelPayment,
      id_integration,
      branch_payment: false,
      id_entity: subsidiary?.id,
      id_assigned_seller: seller?.id_user ?? null,
    },
  };

  const getPassengerName = () =>
    `${passengerDetails?.[0]?.description || ''} ${
      passengerDetails?.[1]?.description || ''
    }`.trim();

  const trackingValue = buildTrackingData({
    error: null,
    subsidiary,
    search,
    pricesDetail,
    hotelDetails,
    passenger_email: baseBookingBody?.passenger_email,
    checkIn: baseBookingBody?.checkIn,
  });

  const baseVoucherInfo = {
    email: baseBookingBody.passenger_email,
    name: getPassengerName(),
    id_integration,
    hotelDetailsPay: hotelDetails,
    hotelDetails,
    search,
    pricesDetail,
    subsidiary,
    seller,
    total,
    room,
    price,
    cardData,
  };

  try {
    const resultBooking = await getHotelSales(bookingBody, detailTransaction);

    const voucherInfo = {
      ...baseVoucherInfo,
      bookingResponse: resultBooking,
      pagos: true,
      bookingError: false,
      errorType: null,
      errorMessage: null,
      cancelationFee,
      validate: hotelsValidateResult,
    };

    dispatch(saveVoucherInfo(voucherInfo));

    trackEvent({ eventName: 'hotelCompra', eventProps: trackingValue, user });

    history.push({ pathname: HOTEL_VOUCHER, state: { ...voucherInfo } });
  } catch (error) {
    console.error('sales error', error);

    const paymentResult = error?.response?.data?.details?.paymentResult;
    const bookingResult = error?.response?.data?.details;

    const { errorType, errorMessage } = getBookingErrorInfo({
      error,
      paymentResult,
    });

    // Tracking del error
    trackEvent({
      eventName: 'hotelCompraErrorTarjeta',
      eventProps: { ...trackingValue, message: errorMessage },
      user,
    });

    if (paymentResult) {
      // Guardar info del voucher aunque haya error

      const voucherInfo = {
        ...baseVoucherInfo,
        bookingResponse: bookingResult,
        pagos: true,
        bookingError: true,
        errorType,
        errorMessage,
      };

      dispatch(saveVoucherInfo(voucherInfo));

      history.push({ pathname: HOTEL_VOUCHER, state: { ...voucherInfo } });
    } else {
      // Mostrar error al usuario
      showBillingError({
        title: 'Ocurrió un error al procesar la compra',
        message: errorMessage,
        subText: '',
      });
    }
  }
};
